import React from "react";
import { motion } from "framer-motion";

export const Stats = ({ data, capabilities }) => {
  const items = data || [];
  const stack = capabilities || [];

  return (
    <section id="stats" className="relative border-b border-line bg-navy-50/60 py-16">
      <div className="container">
        <dl className="grid grid-cols-2 gap-x-8 gap-y-10 lg:grid-cols-4">
          {items.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="relative text-center lg:text-left"
            >
              <dt className="sr-only">{stat.label}</dt>
              <dd>
                <span className="block font-display text-4xl font-extrabold tracking-tight text-navy-900 md:text-5xl">
                  {stat.value}
                </span>
                <span className="mt-2 block text-sm font-medium text-ink-muted">
                  {stat.label}
                </span>
              </dd>
            </motion.div>
          ))}
        </dl>

        {stack.length > 0 && (
          <div className="mt-14">
            <p className="text-center text-xs font-semibold uppercase tracking-[0.18em] text-ink-faint">
              The stack we build on
            </p>

            {/* Duplicated track — the -50% translate makes the loop seamless */}
            <div className="mask-x mt-6 overflow-hidden">
              <div className="animate-marquee flex w-max gap-3">
                {[...stack, ...stack].map((tech, i) => (
                  <span
                    key={`${tech}-${i}`}
                    className="whitespace-nowrap rounded-full border border-line bg-white px-5 py-2 text-sm font-medium text-ink-soft shadow-xs"
                    aria-hidden={i >= stack.length}
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
